import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ContentContext = createContext({ c: (k, f) => f, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});

  const load = useCallback(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const c = useCallback((key, fallback = "") => content[key] ?? fallback, [content]);

  return <ContentContext.Provider value={{ c, content, refresh: load }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
